module.exports = __webpack_public_path__ + "img/1.7bf500b8.png";